import $ from 'jquery'
import { Popup } from './popup'

const debug = require('debug')('pm:open-in-editor-modal')
debug('loaded')

function followChoice(choice, codeUrl, visualDuplicateUrl) {
  if (choice === 'code') {
    window.location.assign(codeUrl)
    return
  }

  const $form = $('#js-duplicate-to-visual-editor-form')
  $form.attr('action', visualDuplicateUrl).trigger('submit')
}

export function openInEditorModal(codeUrl, visualDuplicateUrl) {
  if (!codeUrl || !visualDuplicateUrl) return

  const POPUP_CLASSES = 'c-popup c-popup--large'
  $('#popup').addClass(POPUP_CLASSES)
  Popup.open()
  Popup.showContent($('#js-open-in-editor-modal').html())

  $('#popup')
    .off('click.openInEditor popupCloseEvent.openInEditor')
    .on('click.openInEditor', '[data-open-in-editor-action]', function (event) {
      const choice = $(this).data('open-in-editor-action')
      Popup.close(event)
      followChoice(choice, codeUrl, visualDuplicateUrl)
    })
    .one('popupCloseEvent.openInEditor', function () {
      $(this).removeClass(POPUP_CLASSES)
    })
}

$(document).on('click', '.js-open-in-editor-trigger', function (e) {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.which === 2) return

  const { codeUrl, visualDuplicateUrl } = $(this).data()
  if (!codeUrl || !visualDuplicateUrl) return

  e.preventDefault()
  openInEditorModal(codeUrl, visualDuplicateUrl)
})
